/**
 * @generated SignedSource<<fecdcc75b26bc4a7c66c9b1cc8d37e50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateAddFlightDialog_packageDate$data = {
  readonly end: string;
  readonly id: string;
  readonly start: string;
  readonly " $fragmentType": "PackageDateAddFlightDialog_packageDate";
};
export type PackageDateAddFlightDialog_packageDate$key = {
  readonly " $data"?: PackageDateAddFlightDialog_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateAddFlightDialog_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "b94b7de41870367c0c6e52c405651d22";

export default node;
